module.exports = __webpack_public_path__ + "media/images/shopify-9d664c5f7102a93859964de4e1b9a5dd.svg";